import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useContext } from 'react';
import { FormContext } from './FormContext';
export const FormCheckInput = /*#__PURE__*/ React.forwardRef(({ id, className, type = 'checkbox', isSuccess = false, isWarning = false, isError = false, isStatic, componentClass: Component = 'input', ...props }, ref)=>{
    const { controlId } = useContext(FormContext);
    const bsPrefix = 'form-check-input';
    return /*#__PURE__*/ _jsx(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: classNames(className, bsPrefix, isSuccess && 'is-success', isWarning && 'is-warning', isError && 'is-error', isStatic && 'position-static')
    });
});
FormCheckInput.displayName = 'FormCheckInput';
